/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
(function(a) {
  a.fn.prepareTransition = function() {
    return this.each(function() {
      var b = a(this);
      b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd", function() {
        b.removeClass("is-transitioning")
      });
      var c = ["transition-duration", "-moz-transition-duration", "-webkit-transition-duration", "-o-transition-duration"];
      var d = 0;
      a.each(c, function(a, c) {
        d = parseFloat(b.css(c)) || d
      });
      if (d != 0) {
        b.addClass("is-transitioning");
        b[0].offsetWidth
      }
    })
  }
})(jQuery);

/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e,r,a){var n=new RegExp("("+r+"=).*?(&|$)"),c=e;return c=e.search(n)>=0?e.replace(n,"$1"+a+"$2"):c+(c.indexOf("?")>0?"&":"?")+r+"="+a};

/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

// Timber functions
window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html                    : $('html'),
    $body                    : $(document.body),

    // Navigation
    $navigation              : $('#AccessibleNav'),
    $mobileSubNavToggle      : $('.mobile-nav__toggle'),

    // Collection Pages
    $changeView              : $('.change-view'),

    // Product Page
    $productImage            : $('#ProductPhotoImg'),
    $thumbImages             : $('#ProductThumbs').find('a.product-single__thumbnail'),

    // Customer Pages
    $recoverPasswordLink     : $('#RecoverPassword'),
    $hideRecoverPasswordLink : $('#HideRecoverPasswordLink'),
    $recoverPasswordForm     : $('#RecoverPasswordForm'),
    $customerLoginForm       : $('#CustomerLoginForm'),
    $passwordResetSuccess    : $('#ResetSuccess')
  };
};

timber.init = function () {
  var $body = $('body');

  FastClick.attach(document.body);
  timber.cacheSelectors();
  timber.accessibleNav();
  timber.drawersInit();
  timber.mobileNavToggle();
  timber.productImageSwitch();
  timber.zoom();
  timber.responsiveVideos();
  timber.collectionViews();
  timber.loginForms();
  //if ($body.hasClass('template-collection')) timber.productImageFade();
  timber.preloadBoutiqueImage();
  timber.preloadProductImages();
  timber.preloadLookbookImages();
  // timber.lookbookSwitch();

  timber.socialSharer();

  var $personalizeCheckbox = $('#enable_giftwrapping');
  var $personalizeWrap = $('#card-message-wrap');
  var $personalizeText = $('#card_message');
   if($personalizeText.length) {
        var checkboxValue = $personalizeCheckbox[0].checked;
        timber.personalizeProductCheckbox($personalizeCheckbox,$personalizeText,$personalizeWrap); 
     
      }

  if ($body.hasClass('template-collection')) new SizeFilter();
  //if ($body.attr('id') == 'lookbook') new LookBook();
};

timber.socialSharer = function() {

    this.params = {
        selector: undefined,
        facebookSelector: undefined,
        twitterSelector: undefined,
        linkedinSelector: undefined,
        popupHeight: undefined,
        popupWidth: undefined
    };

    this.defaults = {
        selector: '.js-social-sharer',
        facebookSelector: '.js-social-sharer--facebook',
        twitterSelector: '.js-social-sharer--twitter',
        linkedinSelector: '.js-social-sharer--linkedin',
        popupHeight: 300,
        popupWidth: 500
    };

    this.construct = function(params) {
        var scope = this;
        if (typeof params === typeof undefined) params = {};

        var key;
        for (key in scope.params) {
            if (scope.params.hasOwnProperty(key)) {
                if (params.hasOwnProperty(key)) {
                    scope.params[key] = params[key];
                } else {
                    scope.params[key] = scope.defaults[key];
                }
            }
        }

        scope.initPinterest();
        scope.bindListeners();
    };

    this.bindListeners = function() {
        var scope = this;
        var $body = $('body');
        $body.on('click', scope.params.selector, function(ev) { return scope.listeners.shareClick(scope, ev); });
    };

    this.listeners = this.listeners ||{};
    this.listeners.shareClick = function(scope, ev) {
        var $elt = $(ev.target).is(scope.params.selector) ? $(ev.target) : $(ev.target).parents(scope.params.selector).first();

        if ($elt.is(scope.params.facebookSelector)) {
            scope.shareFacebook();
        } else if ($elt.is(scope.params.twitterSelector)) {
            scope.shareTwitter();
        } else if ($elt.is(scope.params.linkedinSelector)) {
            scope.shareLinkedin();
        } else {
            return true;
        }

        ev.preventDefault();
        return false;
    };

    this.getPopupFeatures = function() {
        var scope = this;
        return 'location=yes,width=' + scope.params.popupWidth + ',height=' + scope.params.popupHeight;
    };

    this.shareFacebook = function(url) {
        var scope = this;
        if (typeof url === typeof undefined) url = window.location.href;

        window.open('https://www.facebook.com/sharer.php?u=' + url, '_blank', scope.getPopupFeatures());
    };

    this.shareTwitter = function(url, msg, hashtags) {
        var scope = this;
        if (typeof url === typeof undefined) url = window.location.href;
        if (typeof msg === typeof undefined) msg = '';
        if (typeof hashtags === typeof undefined || !Util.isArray(hashtags)) hashtags = [];

        window.open('http://twitter.com/share?url=' + url + '&text=' + msg + '&hashtags=' + hashtags.join(','),
            '_blank', scope.getPopupFeatures());
    };

    this.shareLinkedin = function(url) {
        var scope = this;
        if (typeof url === typeof undefined) url = window.location.href;

        window.open('https://www.linkedin.com/shareArticle?mini=true&url=' + url, '_blank', scope.getPopupFeatures());
    };

    this.initPinterest = function() {
        var scope = this;
        var $btns = $('.js-social-sharer--pinterest');
        var i, $btn;
        for (i = 0; i < $btns.length; i++) {
            $btn = $($btns[i]);
            $btn.attr('data-pin-media', $btn.attr('href'))
                .attr('href', 'https://www.pinterest.com/pin/create/button')
                .attr('data-pin-do', 'buttonPin')
                .attr('data-pin-custom', 'true')
            ;
        }
        if ($btns.length) $('body').append($('<script type="text/javascript" async defer src="//assets.pinterest.com/js/pinit.js"></script>'));
        return scope;
    };

    this.construct(arguments[0]);
}


timber.personalizeProductCheckbox = function ($personalizeCheckbox,$personalizeText,$personalizeWrap) {
  
  $personalizeWrap.hide();

  var checkboxValue = $personalizeCheckbox.checked;


  $personalizeCheckbox.off('change');
  $personalizeCheckbox.on('change', (e) => {
  var checkboxValue = e.target.checked;

    timber.personalizeProduct(checkboxValue,$personalizeText,$personalizeWrap);
  });

}



timber.personalizeProduct = function (checkboxValue, $personalizeText,$personalizeWrap) {

  if(checkboxValue) {
    $personalizeWrap.show();
    $personalizeText.focus();
   
  } else {
    $personalizeText.val(''); 
    $personalizeWrap.hide(); 
  }
  
 
}


timber.accessibleNav = function () {
  var $nav = timber.cache.$navigation,
      $allLinks = $nav.find('a'),
      $topLevel = $nav.children('li').find('a'),
      $parents = $nav.find('.site-nav--has-dropdown'),
      $subMenuLinks = $nav.find('.site-nav__dropdown').find('a'),
      activeClass = 'nav-hover',
      focusClass = 'nav-focus';

  // Mouseenter
  $parents.on('mouseenter touchstart', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(activeClass)) {
      evt.preventDefault();
    }

    showDropdown($el);
  });

  // Mouseout
  $parents.on('mouseleave', function() {
    hideDropdown($(this));
  });

  $subMenuLinks.on('touchstart', function(evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $allLinks.focus(function() {
    handleFocus($(this));
  });

  $allLinks.blur(function() {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus ($el) {
    var $subMenu = $el.next('ul'),
        hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
        isSubItem = $('.site-nav__dropdown').has($el).length,
        $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if (!isSubItem) {
      removeFocus($topLevel);
      addFocus($el);
    } else {
      $newFocus = $el.closest('.site-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown ($el) {
    $el.addClass(activeClass);

    setTimeout(function() {
      timber.cache.$body.on('touchstart', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown ($el) {
    $el.removeClass(activeClass);
    timber.cache.$body.off('touchstart');
  }

  function addFocus ($el) {
    $el.addClass(focusClass);
  }

  function removeFocus ($el) {
    $el.removeClass(focusClass);
  }
};

timber.drawersInit = function () {
  timber.LeftDrawer = new timber.Drawers('NavDrawer', 'left');
  
    timber.RightDrawer = new timber.Drawers('CartDrawer', 'right', {
      'onDrawerOpen': ajaxCart.load
    });
  
  timber.SecondRightDrawer = new timber.Drawers('AccountDrawer', 'right', {second: true});
  timber.ThirdRightDrawer = new timber.Drawers('WishlistDrawer', 'right', {third: true});
};

timber.mobileNavToggle = function () {
  timber.cache.$mobileSubNavToggle.on('click', function() {
    $(this).parent().toggleClass('mobile-nav--expanded');
  });
};

timber.getHash = function () {
  return window.location.hash;
};

timber.productPage = function (options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector;

  // Selectors
  var $productImage = $('#ProductPhotoImg'),
      $addToCart = $('#AddToCart'),
      $productPrice = $('#ProductPrice'),
      $comparePrice = $('#ComparePrice'),
      $quantityElements = $('.quantity-selector, label + .js-qty'),
      $addToCartText = $('#AddToCartText'),
      $contactUs = $('#contactUsButton');

 // console.log(variant);
  if (variant) {

    // Update variant image, if one is set
    if (variant.featured_image) {
      var newImg = variant.featured_image,
          el = $productImage[0];
      Shopify.Image.switchImage(newImg, el, timber.switchImage);
    }

      var comingSoon = false;
      var tagsList = options.selector.product.tags + "";
    //  console.log(tagsList);
      if(tagsList.indexOf('contact-order') != -1){
          comingSoon = true;
      }

    // Select a valid variant if available
    if (variant.available) {
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartText.html("Add to shopping bag");
      $quantityElements.show();
      //console.log('buy, but coming soon');
      $addToCart.show();
      $contactUs.hide();
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      if(!comingSoon) {
         // console.log('not coming soon');
          $addToCart.addClass('disabled').prop('disabled', true);
          $addToCartText.html("Sold Out");
          $quantityElements.hide();
      } else {
        //  console.log('coming soon');
          $addToCart.hide();
          $contactUs.show();
          $contactUs.attr('href', $contactUs.attr('href').replace(/Size:.+&body/,"Size:"+ variant.title +"&body"));
      }

    }

    // Regardless of stock, update the product price
    $productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );

    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice
        .html("Compare at" + ' ' + Shopify.formatMoney(variant.compare_at_price, moneyFormat))
        .show();
    } else {
      $comparePrice.hide();
    }

  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html("Add to shopping bag");
    $quantityElements.hide();
  }
};

timber.productImageSwitch = function () {
  if (timber.cache.$thumbImages.length) {
    // Switch the main image with one of the thumbnails
    // Note: this does not change the variant selected, just the image
    timber.cache.$thumbImages.on('click', function(evt) {
      evt.preventDefault();
      var newImage = $(this).attr('href');
      timber.switchImage(newImage, null, timber.cache.$productImage);
    });
  }
};

timber.switchImage = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('src', src);
};

timber.zoom = function() {

    if($(window).outerWidth( true ) > 768){
        $('.zoom-img').zoom({
            magnify: 2,
            on: 'grab',
        }); // add zoom
    } else {
        $('.zoom-img').zoom({
            magnify: 1,
            on: 'click',
            touch: true
        }); // add zoom
    }
};

timber.responsiveVideos = function () {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    $(this).wrap('<div class="video-wrapper"></div>');
  });

  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

timber.collectionViews = function () {
 if (timber.cache.$changeView.length) {
   timber.cache.$changeView.on('click', function() {
     var view = $(this).data('view'),
         url = document.URL,
         urlWithoutHash = url.split('#')[0],
         hasParams = url.indexOf('?') > -1,
         location = '';

     if (hasParams) {
       location = replaceUrlParam(urlWithoutHash, 'view', view);
     } else {
       location = urlWithoutHash + '?view=' + view;
     }

     if(url.indexOf('#') > -1) {
       var hash = url.substring(url.indexOf('#')+1);
       location += '#' + hash;
     }

     window.location = location;
   });
 }
};

timber.loginForms = function() {
  function showRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.show();
    timber.cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.hide();
    timber.cache.$customerLoginForm.show();
  }

  timber.cache.$recoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  timber.cache.$hideRecoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Allow deep linking to recover password form
  if (timber.getHash() == '#recover') {
    showRecoverPasswordForm();
  }
};

timber.resetPasswordSuccess = function() {
  timber.cache.$passwordResetSuccess.show();
};

/*============================================================================
  Drawer modules
  - Docs http://shopify.github.io/Timber/#drawers
==============================================================================*/
timber.Drawers = (function () {
  var Drawer = function (id, position, options) {
    var suffix = '';
    if (typeof options != typeof undefined && options.second) suffix = '-second';
    if (typeof options != typeof undefined && options.third) suffix = '-third';
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position + suffix,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position + suffix,
      second: false,
      third: false
    };

    this.$nodes = {
      parent: $('body, html'),
      page: $('#PageContainer'),
      moved: $('.is-moved-by-drawer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function () {
    $(this.config.open).on('click', $.proxy(this.open, this));
    //this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
    this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    /**if (!this.drawerIsOpen) {
      if (this.position == "left") {
        if (timber.RightDrawer.drawerIsOpen) {
          timber.RightDrawer.close();
          timber.RightDrawer.drawerIsOpen = false;
        }
        if (timber.SecondRightDrawer.drawerIsOpen) {
          timber.SecondRightDrawer.close();
          timber.SecondRightDrawer.drawerIsOpen = false;
        }
      } else {
        if (timber.LeftDrawer.drawerIsOpen) {
          timber.LeftDrawer.close();
          timber.LeftDrawer.drawerIsOpen = false;
        }
        if (this.config.second) {
          if (timber.RightDrawer.drawerIsOpen) {
            timber.RightDrawer.close();
            timber.RightDrawer.drawerIsOpen = false;
          }
        } else {
          if (timber.SecondRightDrawer.drawerIsOpen) {
            timber.SecondRightDrawer.close();
            timber.SecondRightDrawer.drawerIsOpen = false;
          }
        }
      }
      if (this.position == "left" && timber.RightDrawer.drawerIsOpen) {
        timber.RightDrawer.close();
        timber.RightDrawer.drawerIsOpen = false;
      } else if (timber.LeftDrawer.drawerIsOpen) {
        timber.LeftDrawer.close();
        timber.LeftDrawer.drawerIsOpen = false;
      }
    }**/

    if (this.config.dirOpenClass == 'js-drawer-open-right-third') {
      try {
        localStorage.setItem('availability_check', 'check');
      } catch (quotaExceeded) {
        alert('The wish list is not available while browsing privately.');
        return;
      }
    }

    if (!this.drawerIsOpen) {
      if (this.position == "left") {
        if (timber.RightDrawer.drawerIsOpen) {
          timber.RightDrawer.close();
          timber.RightDrawer.drawerIsOpen = false;
        }
        if (timber.SecondRightDrawer.drawerIsOpen) {
          timber.SecondRightDrawer.close();
          timber.SecondRightDrawer.drawerIsOpen = false;
        }
        if (timber.ThirdRightDrawer.drawerIsOpen) {
          timber.ThirdRightDrawer.close();
          timber.ThirdRightDrawer.drawerIsOpen = false;
        }
      } else {
        if (timber.LeftDrawer.drawerIsOpen) {
          timber.LeftDrawer.close();
          timber.LeftDrawer.drawerIsOpen = false;
        }
        if (this.config.second) {
          if (timber.RightDrawer.drawerIsOpen) {
            timber.RightDrawer.close();
            timber.RightDrawer.drawerIsOpen = false;
          }
          if (timber.ThirdRightDrawer.drawerIsOpen) {
            timber.ThirdRightDrawer.close();
            timber.ThirdRightDrawer.drawerIsOpen = false;
          }
        } else if (this.config.third) {
          if (timber.SecondRightDrawer.drawerIsOpen) {
            timber.SecondRightDrawer.close();
            timber.SecondRightDrawer.drawerIsOpen = false;
          }
          if (timber.RightDrawer.drawerIsOpen) {
            timber.RightDrawer.close();
            timber.RightDrawer.drawerIsOpen = false;
          }
        } else {
          if (timber.SecondRightDrawer.drawerIsOpen) {
            timber.SecondRightDrawer.close();
            timber.SecondRightDrawer.drawerIsOpen = false;
          }
          if (timber.ThirdRightDrawer.drawerIsOpen) {
            timber.ThirdRightDrawer.close();
            timber.ThirdRightDrawer.drawerIsOpen = false;
          }
        }
      }
      if (this.position == "left" && timber.RightDrawer.drawerIsOpen) {
        timber.RightDrawer.close();
        timber.RightDrawer.drawerIsOpen = false;
      } else if (timber.LeftDrawer.drawerIsOpen) {
        timber.LeftDrawer.close();
        timber.LeftDrawer.drawerIsOpen = false;
      }
    }

    var $drawerOverlay = $('.drawer-overlay');
    if ($drawerOverlay.length) {
    if (!$drawerOverlay.hasClass('display')) $drawerOverlay.addClass('display');
      setTimeout(function () {
        if (!$drawerOverlay.hasClass('active')) $drawerOverlay.addClass('active');
      }, 100);
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Notify the drawer is going to open
    timber.cache.$body.trigger('beforeDrawerOpen.timber', this);

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$nodes.moved.addClass('is-transitioning');
    this.$drawer.prepareTransition();

    this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Set focus on drawer
    this.trapFocus(this.$drawer, 'drawer_focus');

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    // Lock scrolling on mobile
    this.$nodes.page.on('touchmove.drawer', function () {
      return false;
    });

    this.$nodes.page.on('click.drawer', $.proxy(function () {
      this.close();
      return false;
    }, this));

    // Notify the drawer has opened
    timber.cache.$body.trigger('afterDrawerOpen.timber', this);
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    var $drawerOverlay = $('.drawer-overlay');
    if ($drawerOverlay.length) {
      if ($drawerOverlay.hasClass('active')) $drawerOverlay.removeClass('active');
      setTimeout(function () {
        if ($drawerOverlay.hasClass('display')) $drawerOverlay.removeClass('display');
      }, 220);
    }

    // Notify the drawer is going to close
    timber.cache.$body.trigger('beforeDrawerClose.timber', this);

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$nodes.moved.prepareTransition({ disableExisting: true });
    this.$drawer.prepareTransition({ disableExisting: true });

    this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    this.removeTrapFocus(this.$drawer, 'drawer_focus');

    this.$nodes.page.off('.drawer');

    // Notify the drawer is closed now
    timber.cache.$body.trigger('afterDrawerClose.timber', this);
  };

  Drawer.prototype.trapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.attr('tabindex', '-1');

    $container.focus();

    $(document).on(eventName, function (evt) {
      if ($container[0] !== evt.target && !$container.has(evt.target).length) {
        $container.focus();
      }
    });
  };

  Drawer.prototype.removeTrapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.removeAttr('tabindex');
    $(document).off(eventName);
  };

  return Drawer;
})();

timber.productImageFade = function() {
	$(window).on('scroll', function() {
		var windowWidth = $(window).width();
		if (windowWidth >= 768) {
			var $imgs = $('.fade-on-scroll');
			if ($imgs.length) {
				var scroll = $(document).scrollTop();
				var headerHeight = $('.site-header').outerHeight();
				var minOpacity = 0.3;
				var maxOpacity = 1;
				var fadeDistance = headerHeight * 0.35;
				var fadeAdjustment = -headerHeight * 1;
				var i, $img, imgTop, distToTop;
				for (i = 0; i < $imgs.length; i++) {
					$img = $($imgs[i]);
					imgTop = $img.offset().top;
					distToTop = Math.max(imgTop - scroll, 0);
					if (distToTop < headerHeight + fadeAdjustment) {
						$img.css('opacity', minOpacity);
					} else if (distToTop >= headerHeight + fadeDistance + fadeAdjustment) {
						$img.css('opacity', maxOpacity);
					} else {
						$img.css('opacity', minOpacity + ((distToTop - headerHeight - fadeAdjustment) / fadeDistance) * (maxOpacity - minOpacity));
					}
				}
			}
		}
	}).scroll();
};

timber.preloadProductImages = function() {
  var $body = $('body');
  if ($body.hasClass('template-product')) {
    var preLoader = new ImagePreloader({
      imgSelector: '.fade-on-scroll',
      ready: function($elements) {
        console.log('callback');
        var i;
        var $element;
        for (i = 0; i < $elements.length; i++) {
          $element = $($elements[i]);
          $element.addClass('visible');
        }
        //timber.productImageFade();
      }
    });
  }
};

timber.preloadBoutiqueImage = function() {
  var $body = $('body');
  if ($body.attr('id') == 'boutique') {
    var preLoader = new ImagePreloader({
      imgSelector: '.storefront',
      ready: function($elements) {
        var i;
        var $element;
        for (i = 0; i < $elements.length; i++) {
          $element = $($elements[i]);
          $element.addClass('visible');
        }
      }
    });
  }
};

timber.preloadLookbookImages = function() {
	var $body = $('body');
	if ($body.attr('id').indexOf("lookbook") >= 0) {
		var preLoader = new ImagePreloader({
			imgSelector: '.preload-image',
			ready: function($elements) {
				var i;
				var $element;
				for (i = 0; i < $elements.length; i++) {
					$element = $($elements[i]);
					$element.addClass('visible');
				}
				$('.fade-in').addClass('visible');
			}
		});
	}
};

// timber.lookbookSwitch = function() {
//   $('.SS-nav').on('click', function() {
//     if(! ($(this).hasClass('active')) ){
//       $('.FW-nav').removeClass('active');
//       $('.SS-nav').addClass('active');
//       $('.SS18-nav').removeClass('active');
//       $('.SS18').toggle();
//       $('.SS').toggle();
//       $('.FW').toggle();
//     }
//   });
//   $('.FW-nav').on('click', function() {
//     if(! ($(this).hasClass('active')) ){
//       $('.FW-nav').addClass('active');
//       $('.SS-nav').removeClass('active');
//       $('.SS18-nav').removeClass('active');
//       $('.SS18').toggle();
//       $('.FW').toggle();
//       $('.SS').toggle();
//     }
//   });
//   $('.SS18-nav').on('click', function() {
//     if(! ($(this).hasClass('active')) ){
//       $('.FW-nav').removeClass('active');
//       $('.SS-nav').removeClass('active');
//       $('.SS18-nav').addClass('active');
//       $('.SS18').toggle();
//       $('.FW').toggle();
//       $('.SS').toggle();
//     }
//   });
// }

timber.linkProductBySize = function() {
  var $body = $('body');
  if ($body.hasClass('template-product')) {

    $body.on('change', '[data-option="option1"]', function(ev) {
      var $elt = $(ev.target);
      if ($elt.val() !== null) $('.iWishAdd').prop('disabled', false);
    });
    $(window).on('hashchange', function(ev) {
      var hash = window.location.hash;
      if (hash.length) {
        if (hash.substr(0, 1) == '#') hash = hash.substr(1);
      }
      var size;
      if (hash.match(new RegExp('^size\-[a-zA-Z0-9\,]+$'))) {
        size = hash.replace(new RegExp('^size\-([a-zA-Z0-9\,]+)$'), '$1');
      } else {
        size = undefined;
      }

      if (typeof size === typeof undefined && Shopify.urlParam('variant') !== null) {
        var variantId = Shopify.urlParam('variant');
        var $option = $('option[data-variant-id="' + variantId + '"]');
        if ($option.length) size = $option.attr('value');
      }

      var $select = $('[data-option="option1"]');
      if (typeof size !== typeof undefined) {
        $select.val(size);
      } /*else {
        size = $select.find('option:not(:disabled)').first().attr('value');
        $select.val(size);
      }*/
      $select.change();
    }).trigger('hashchange');
  }
};

// Initialize Timber's JS on docready
$(timber.init);
